import {
    useAddProductsToWishlist,
    AddWishlistVariableInterface
} from './use-add-products-to-wishlist'
import { useUI, ToastType } from '@corratech/pylot-ui/context'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import useIsMobile from '@lib/hooks/useIsMobile'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

export interface UseWishlistActionInterface {
    handleAddWishlistAction: (
        itemsData: AddWishlistVariableInterface,
        isConfig: boolean,
        stayOnPage?: boolean,
        onSuccess?: () => void
    ) => void
    isLoading: boolean
}

export const useWishlistActions = (): UseWishlistActionInterface => {
    const { t } = useTranslation(['wishlist'])
    const { openToast, openCartToast } = useUI()
    const { addProductsToWishlist, isLoading } = useAddProductsToWishlist()
    const router = useRouter()
    const config = useStoreConfig()
    const isMobile = useIsMobile()

    const handleAddWishlistAction = async (
        itemsData: AddWishlistVariableInterface,
        isConfig: boolean,
        stayOnPage?: boolean,
        onSuccess?: () => void
    ) => {
        const openToastFunction = isMobile ? openToast : openCartToast

        if (isConfig && !itemsData?.itemOptions[0]?.selected_options?.length) {
            openToastFunction(
                t('wishlist|Please select a variant with stock to proceed.'),
                ToastType.Danger
            )
            return false
        }

        const response = await addProductsToWishlist(itemsData)
        if (response?.errors?.length) {
            //handle errors
            openToastFunction(
                t('wishlist|Something went wrong. Please try again'),
                ToastType.Danger
            )
        }

        if (response?.data?.addProductsToWishlist?.wishlist) {
            const { id: routeId } = response.data.addProductsToWishlist.wishlist
            const redirectUrl = config.base.wishlist.multiple_wishlists
                ? `/account/wishlist/${routeId}`
                : '/account/wishlist'

            if (stayOnPage) {
                // Same banner as minicart/checkout (CartToast) at top of the lists panel
                openCartToast(
                    t('wishlist|Product has been added to your Wish List.'),
                    ToastType.Success
                )
                setTimeout(() => {
                    if (onSuccess) {
                        onSuccess()
                    }
                }, 2000)
            } else {
                router.push(redirectUrl).then(() => {
                    openToastFunction(
                        t('wishlist|Product has been added to your Wish List.'),
                        ToastType.Success
                    )
                })
                setTimeout(() => {
                    if (onSuccess) {
                        onSuccess()
                    }
                }, 2000)
            }
        }
    }

    return {
        handleAddWishlistAction,
        isLoading
    }
}
